import AlertBell from '../../src/legacy/AlertBell';
export default AlertBell;
